import {
  DOWNLOAD_REPORT_CSV,
  FREE_SUBSCRIPTION_DATA,
  GET_COURSES_REPORT,
  GET_INDIVIDUAL_COURSES_REPORT,
  GET_ALL_USER_REPORT,
  GET_ALL_FREE_CLASS_REPORT,
  GET_PRE_CLG_APPLICATION_SUBMITTED,
  TOTAL_ENTOLLMENT,
  COURSE_ENTOLLMENT,
  SALES_COURSE_PURCHASE_DATA,
  SALES_PAYMENT_PENDING,
  SALES_OVERVIEW,
  GET_CERT_APPLICATION_SUBMITTED,
  TOTAL_CERT_ENTOLLMENT,
  GET_Dl_APPLICATION_SUBMITTED,
  TOTAL_Dl_ENTOLLMENT,
  SALES_APP_PURCHASE,
} from "../constants";

const initialState = {
  freeSubscriptionDetails: [],
  courseReportList: [],
  individualCourseList: [],
  userReportList: [],
  freeClassReportList: [],
  applicationSubmittedData: [],
  courseEnrollmentData: [],
  salesReport: [],
  enrollCourse: [],
  applicationCertSubmittedData:[],
  courseCertEnrollmentData:[],
  applicationDlSubmittedData:[],
  coursetDlEnrollmentData:[]
};

export const reportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DOWNLOAD_REPORT_CSV: {
      state = [payload];
      return state;
    }
    case FREE_SUBSCRIPTION_DATA: {
      return {
        ...state,
        freeSubscriptionDetails: payload,
      };
    }
    case GET_COURSES_REPORT: {
      return {
        ...state,
        courseReportList: payload,
      };
    }
    case GET_INDIVIDUAL_COURSES_REPORT: {
      return {
        ...state,
        individualCourseList: payload,
      };
    }
    case GET_ALL_USER_REPORT: {
      return {
        ...state,
        userReportList: payload,
      };
    }
    case GET_ALL_FREE_CLASS_REPORT: {
      return {
        ...state,
        freeClassReportList: payload,
      };
    }
    case GET_PRE_CLG_APPLICATION_SUBMITTED: {
      return {
        ...state,
        applicationSubmittedData: payload,
      };
    }
    case TOTAL_ENTOLLMENT: {
      return {
        ...state,
        courseEnrollmentData: payload,
      };
    }
    case COURSE_ENTOLLMENT: {
      return {
        ...state,
        enrollCourse: payload,
      };
    }
    case SALES_COURSE_PURCHASE_DATA: {
      return {
        ...state,
        salesReport: payload,
      };
    }
    case SALES_PAYMENT_PENDING: {
      return {
        ...state,
        salesReport: payload,
      };
    }
    case SALES_OVERVIEW:{
      return {
        ...state,
        salesReport: payload,
      }
    }
    case SALES_APP_PURCHASE:{
      return {
        ...state,
        salesReport: payload,
      }
    }
    case GET_CERT_APPLICATION_SUBMITTED:{
      return {
        ...state,
        applicationCertSubmittedData:payload,
      }
    }
    case GET_Dl_APPLICATION_SUBMITTED:{
      return {
        ...state,
        applicationDlSubmittedData:payload,
      }
    }
    case TOTAL_CERT_ENTOLLMENT: {
      return {
        ...state,
        courseCertEnrollmentData: payload,
      };
    }
    case TOTAL_Dl_ENTOLLMENT: {
      return {
        ...state,
        coursetDlEnrollmentData: payload,
      };
    }
    default: {
      return state;
    }
  }
};
